import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const GridT3 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      id="Group_14979"
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 23.38 16.504"
      {...rest}
      fill={fill}
    >
      <rect
        id="Rectangle_3165"
        fill="#b5b5be"
        width="6.189"
        height="14.441"
        transform="translate(1.375 1.246)"
      />
      <path
        id="grid_4"
        fill="#383e43"
        d="M29.005,12a1.375,1.375,0,0,1,1.375,1.375V27.129A1.375,1.375,0,0,1,29.005,28.5H8.375A1.375,1.375,0,0,1,7,27.129V13.375A1.375,1.375,0,0,1,8.375,12Zm0,15.129V13.375H15.94V27.129Zm-14.441,0H8.375V13.375h6.189Z"
        transform="translate(-7 -12)"
      />
    </svg>
  );
};

GridT3.displayName = 'GridT3';
